var h = Object.defineProperty;
var b = (r, e, n) => e in r ? h(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n;
var u = (r, e, n) => b(r, typeof e != "symbol" ? e + "" : e, n);
class _ {
  constructor(e) {
    u(this, "logger", null);
    u(this, "events", /* @__PURE__ */ new Map());
    u(this, "publish", (e, n) => {
      var s;
      const t = this.getEventHandlers(e);
      (s = this.logger) == null || s.call(this, "event: ", "publish", `
eventName: `, e, `
params: `, n, `
handlers: `, t), t.forEach((i) => {
        i(n);
      });
    });
    u(this, "subscribe", (e, n) => {
      var s;
      return this.getEventHandlers(e).add(n), (s = this.logger) == null || s.call(this, "event: ", "subscribe", `
event: `, e, `
handler: `, n), () => {
        this.unsubscribe(e, n);
      };
    });
    u(this, "unsubscribe", (e, n) => {
      var s;
      const t = this.getEventHandlers(e);
      if ((s = this.logger) == null || s.call(this, "event: ", "unsubscribe", `
event: `, e, `
handler: `, n), t.size === 0) {
        t.clear();
        return;
      }
      t.delete(n);
    });
    this.logger = e != null ? e : null;
  }
  getEventHandlers(e) {
    let n = this.events.get(e);
    return n || (n = /* @__PURE__ */ new Set(), this.events.set(e, n)), n;
  }
}
function L(r) {
  return Array.isArray(r) ? r.length !== 0 : r != null && r !== "null";
}
class y extends Error {
}
function c(r, e) {
  if (!r)
    throw new y(e);
}
function a(r, e) {
  if (typeof r != typeof e)
    return !1;
  switch (typeof r) {
    case "boolean":
    case "string":
    case "function":
    case "symbol":
    case "undefined":
      return r === e;
    case "bigint":
    case "number":
      return Object.is(r, e);
    case "object": {
      if (c(typeof e == "object", "Assertation error"), r === null && e === null)
        return !0;
      if (r === null || e === null)
        return !1;
      const n = Array.isArray(r), t = Array.isArray(e);
      return n && t ? A(r, e) : n || t ? !1 : T(r, e);
    }
  }
  c(!1, "Assertation error");
}
function A(r, e) {
  if (r.length !== e.length) return !1;
  for (let n = 0; n < r.length; n++) {
    const t = r[n], s = e[n];
    if (!a(t, s))
      return !1;
  }
  return !0;
}
function T(r, e) {
  const n = Object.keys(r).sort(), t = Object.keys(e).sort();
  if (n.length !== t.length)
    return !1;
  for (let s = 0; s < n.length; s++) {
    const i = n[s], o = t[s];
    if (i !== o)
      return !1;
    const f = r[i], E = e[i];
    if (!a(f, E))
      return !1;
  }
  return !0;
}
async function O(r, e = 300) {
  return new Promise((n, t) => {
    setTimeout(() => {
      n(r());
    }, e);
  });
}
const l = {
  ACTIVE_GREEN: "#219653",
  ACTIVE_YELLOW: "#F2C94C",
  ACTIVE_RED: "#EB5757",
  COMPLETED: "#ffffff80"
}, d = "rgba(64, 81, 134, 1)";
function g(r) {
  return (r == null ? void 0 : r.startsWith("light")) === !0;
}
function D(r, e) {
  return r === "COMPLETED" && g(e == null ? void 0 : e.theme) ? d : r in l ? l[r] : r === "ACTIVE" ? l.ACTIVE_GREEN : r === "BAD" ? l.ACTIVE_RED : l.COMPLETED;
}
export {
  y as AssertionError,
  _ as EventBus,
  l as WELL_STATUS_COLORS,
  c as assert,
  a as equalsDeep,
  D as getWellStatusColor,
  L as hasValue,
  O as testRequestWithDelay
};
//# sourceMappingURL=utils.es.js.map
